import React from 'react';
import { Container, Box, Typography, Paper } from '@mui/material';
import { Email } from '@mui/icons-material';

const RegistrationSuccess = () => {
  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          marginBottom: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%'
          }}
        >
          <Email sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
          <Typography component="h1" variant="h4" gutterBottom align="center">
            Registrazione effettuata con successo!
          </Typography>
          <Typography variant="body1" color="text.secondary" align="left" sx={{ mb: 3 }}>
            Ti abbiamo inviato una mail di verifica alla tua casella di posta, aprila prima di effettuare il login.
          </Typography>
          {/* <Button variant="contained" onClick={() => navigate('/login')}>
            Vai al Login
          </Button> */}
        </Paper>
      </Box>
    </Container>
  );
};

export default RegistrationSuccess; 